module.exports = __webpack_public_path__ + "img/20.191374cd.png";